import {
  FETCH_HIGHER_ADJUSTMENTS_REQUEST,
  FETCH_HIGHER_ADJUSTMENTS_SUCCESS,
  FETCH_HIGHER_ADJUSTMENTS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  records: [],
  error: null,
  isFetching: false,
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_HIGHER_ADJUSTMENTS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_HIGHER_ADJUSTMENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        records: action.payload,
      }

    case FETCH_HIGHER_ADJUSTMENTS_ERROR:
      return {
        ...state,
        isFetching: false,
        records: [],
        error: action.payload,
      }

    default:
      return state
  }
}

export default record
